module.exports = __webpack_public_path__ + "static/media/001_slider.f6788c9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/001_slider.jpg
// module id = 760
// module chunks = 0